export enum TipoRequisicaoEnum {
  AprovacaoRARO = 1,
  CancelamentoOperacao,
  AlteracaoDadosPessoais,
  SolicitacaoParceria,
  SolicitacaoPj
}
